export enum Feature {
  FEATURE_EXAMPLE = 'FEATURE_EXAMPLE',
  TENANT_NETWORK_WIDGET = 'TENANT_NETWORK_WIDGET',
  WOMENS_DAY_VOUCHER_MODAL = 'WOMENS_DAY_VOUCHER_MODAL',
}

export interface FeatureSwitch {
  feature: Feature;
  enabled: boolean;
}

export interface FeatureSwitches {
  features: FeatureSwitch[];
}
